import { ChatEngine } from 'react-chat-engine';
import LoginForm from './components/LoginForm';
import ChatFeed from './components/ChatFeed';

import './App.css' ;

const App = () =>{
    if(!localStorage.getItem('username')) return <LoginForm/>
return(
    <ChatEngine
      height="100vh"
      projectID="ac39e4b8-b351-4216-826b-c5bd6ce41f30"
      userName={localStorage.getItem('username')}
      userSecret={localStorage.getItem('password')}
      renderChatFeed={(chatAppProps) => <ChatFeed {... chatAppProps} />}
      />
);
}

export default App;